import React, { useEffect } from "react";

import ViewSDKClient from "./ViewSDKClient";
import "./pdf-reader.css";

const RenderMenu = (props) => {
  const {
    url, //URL of the Pdf to render (Just in Aws case)
    file, // pdf file to render >
    inputId, //id of the input  (just in inputFile case)
    awsURL, //Boolean True if using aws URL if not False
    inputFile, //Boolean True if using InputFile if not False
    isFile, //Boolean True if using InputFile if not False
    fileName = "Nombre del PDF", // Name of the file uploaded
    showDownloadPDF, //Boolean to show Download
    src, //BlobUrl or Url when QA
    useFullHeight = false, // NUEVA PROP para manejar la altura
  } = props;

  let location = window.location.href;
  const loadPDF = () => {
    const viewSDKClient = new ViewSDKClient();
    // //PRUEBA CON PROMESA DE AMAZON
    if (isFile) {
      viewSDKClient.ready().then(() => {
        viewSDKClient.previewFileUsingFilePromise(
          "pdf-div",
          {
            defaultViewMode: "FIT_WIDTH",
            showAnnotationTools: false,
            // showLeftHandPanel: true,
            // showPageControls: true,
            showDownloadPDF: showDownloadPDF ? showDownloadPDF : false,
            showPrintPDF: false,
            // enableLinearization: true
          },
          fileName,
          file
        );
      });
    }

    //PRUEBA CON EL URL
    if (awsURL) {
      viewSDKClient.ready().then(() => {
        viewSDKClient.previewFile(
          "pdf-div",
          {
            defaultViewMode: "FIT_WIDTH",
            showAnnotationTools: false,
            showDownloadPDF: showDownloadPDF ? showDownloadPDF : false,
            showPrintPDF: false,
          },
          url
        );
      });
    }

    // PRUEBA CON EL INPUT
    if (inputFile) {
      viewSDKClient.ready().then(() => {
        viewSDKClient.listenForFileUpload("pdf-div", inputId, {
          defaultViewMode: "FIT_WIDTH",
          showAnnotationTools: false,
          showDownloadPDF: showDownloadPDF ? showDownloadPDF : false,
          showPrintPDF: false,
        });
      });
    }
  };

  useEffect(() => {
    loadPDF();
    return () => {
      // Cleanup logic for Adobe SDK
      const pdfDiv = document.getElementById("pdf-div");
      if (pdfDiv) pdfDiv.innerHTML = ""; // Clear the div content
    };
  }, []);

  return (
    <div className={`global-container-pdf ${useFullHeight ? 'height-100' : ''}`}>
      <div
        id="pdf-div"
        className={`pdf-view-container ${useFullHeight ? 'height-100' : ''}`}
        onLoad={loadPDF()}
        crossOrigin=""
      ></div>
    </div>
  );
  // location.indexOf(process.env.REACT_APP_QA_URL_1) !== -1 ||
  //   location.indexOf(process.env.REACT_APP_QA_URL_2) !== -1 ? (
  //   <iframe
  //     name="document_pdf"
  //     id="myiframe"
  //     width="100%"
  //     height="600px"
  //     src={src}
  //     className="canvas_container_pdf_render"
  //   />
  // ) :
};
export default RenderMenu;
